import React, { createContext, useState, useContext } from "react"
import Helmet from "react-helmet"
import { brand } from "config/brand"
import * as styles from "./styles.module.scss"
import "../../styles/_reset.scss"
import "../../styles/shared/variables/_breakpoints.scss"
import "../../styles/shared/variables/bsk-variables/_breakpoints.scss"
import "../../styles/css-variables/_index.scss"
import "../../styles/fonts/_index.scss"
import "../../styles/icons/_index.scss"
import cx from "classnames"
import imgBetterLogoMetaFill from "./img/better-logo-meta-fill.jpg"
import { useInView } from "react-intersection-observer"

interface DocumentProps {
  brandMetaPrefix?: boolean
  children: React.ReactNode
  description?: string
  keywords?: string
  metaChildren?: React.ReactNode
  pageClass?: string
  pageId?: string
  thumbnail?: string
  title: string
}

export const NavContext = createContext({
  isNavOpen: false,
  toggleNav: null,
  scrolled: false,
})

const Document: React.FC<DocumentProps> = ({
  brandMetaPrefix,
  children,
  description,
  keywords,
  metaChildren,
  pageClass,
  pageId,
  thumbnail,
  title,
  ...props
}) => {
  const metaTitle = `${brandMetaPrefix ? `${brand.name}: ` : ""}${
    title || `${brand.name}: simple, online home finance`
  }`
  const metaDescriptionTwitter = `${brand.legalName} NMLS #330511. ${
    description ||
    `${brand.shortName} is a direct lender dedicated to providing a fast, transparent, and online mortgage experience backed by superior customer support.`
  } Not available in all states. See better.com/about-us/licensing-disclosure.`
  const metaDescriptionOg = `${
    description ||
    `${brand.shortName} is a direct lender dedicated to providing a fast, transparent, and online mortgage experience backed by superior customer support.`
  } ${
    brand.legalName
  } NMLS #330511. Not available in all states. See better.com/about-us/licensing-disclosure.`
  const metaThumbnail = thumbnail || imgBetterLogoMetaFill

  const [isNavOpen, setNavOpen] = useState(false)

  const [scrollRef, scrollRefInView, entryScrollRef] = useInView({
    threshold: 0,
  })

  const toggleNav = () => {
    setNavOpen((isNavOpen) => !isNavOpen)
  }

  return (
    <>
      <Helmet>
        <title>
          {title
            ? `${title} | ${brand.name}`
            : `Simple, Online Home Finance | ${brand.name}`}
        </title>
        <meta
          name="description"
          content={
            description ||
            `Better is a direct lender dedicated to providing a fast, transparent, and online mortgage experience backed by superior customer support.`
          }
        />
        {/* {keywords && <meta name="keywords" content={keywords} />} */}
        <meta name="robots" content="noindex"></meta>
        {/* <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@betterdotcom" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescriptionTwitter} />
        <meta name="twitter:image" content={metaThumbnail} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescriptionOg} />
        <meta property="og:image" content={metaThumbnail} />
        <meta property="og:site_name" content={brand.name} />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/Betterdotcom"
        /> */}
        {metaChildren && metaChildren}
      </Helmet>
      <div
        className={cx({
          [styles.page]: true,
          [pageClass]: true,
        })}
        id={pageId}
        {...props}
      >
        <NavContext.Provider
          value={{ isNavOpen, toggleNav, scrolled: !scrollRefInView }}
        >
          <div className={styles.scrollRef} ref={scrollRef} />
          {children}
        </NavContext.Provider>
      </div>
    </>
  )
}

export default Document
